"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "Filter", {
  enumerable: true,
  get: function get() {
    return _Filter["default"];
  }
});
exports["default"] = exports.createInstance = void 0;

var _axios = _interopRequireDefault(require("axios"));

var _useRequestURLEncoded = _interopRequireDefault(require("./useRequestURLEncoded"));

var _useRequestFilter = _interopRequireDefault(require("./useRequestFilter"));

var _useResponseFilter = _interopRequireDefault(require("./useResponseFilter"));

var _Filter = _interopRequireDefault(require("./Filter"));

var createInstance = function createInstance(preset) {
  var instance = _axios["default"].create({
    validateStatus: function validateStatus() {
      return true;
    }
  });

  instance.interceptors.request.use(_useRequestURLEncoded["default"]);
  instance.interceptors.request.use(_useRequestFilter["default"]);
  instance.interceptors.response.use(_useResponseFilter["default"]);

  if (preset && typeof preset === 'function') {
    preset(instance);
  }

  return instance;
};

exports.createInstance = createInstance;

var _default = createInstance();

exports["default"] = _default;